import React from "react";
import { Banner, EmptyBanner } from "../../stores/BannerStore";
import { Ad } from "./Ad";
import { renderBannerTeaser } from "./Teaser";
import { getAdImages, isEmptyBanner } from "../../utils/BannerUtil";

type PropType = {
    banner: Banner | EmptyBanner;
};

class FullPageBanner extends React.Component<PropType> {
    renderBanner(banner: Banner) {
        if (banner.advertisement) {
            return <Ad key={banner.placementId} images={getAdImages(banner)} className="margin-grid-bottom" />;
        }

        return renderBannerTeaser(banner);
    }

    render() {
        const banner = this.props.banner;
        if (isEmptyBanner(banner)) {
            return null;
        }
        return this.renderBanner(banner as Banner);
    }
}

export default FullPageBanner;
